import * as AuthService from 'Services/AuthService';
import { signoutUser } from './actions';
import { getIsAuthenticated } from './selectors';

export const signOutUserWithExpiredTokensOnLocationChange = store => next => action => {
  // Log-out the user before applying route change to avoid triggering page mount fetches (that will 401)
  if (action.type === '@@router/LOCATION_CHANGE' && getIsAuthenticated(store.getState())) {
    const authTokens = AuthService.getAuth();
    if (
      AuthService.isTokenExpired(authTokens?.refreshToken) && // refresh token is out-of-date or corrupted
      AuthService.isTokenExpired(authTokens?.accessToken) // access token is out-of-date or corrupted
    ) {
      store.dispatch(signoutUser()); // Sign-out the user, this will also remove token from local Storage
    }
  }
  // Redirect after signingOut the user
  return next(action);
};
